import React from "react";
import { motion } from "framer-motion";

// Section scroll-reveal + shared primitives.

export const Reveal = ({ children, delay = 0, y = 24, className = "", as = "div", once = true }) => {
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: "-80px" }}
      transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
      className={className}
    >
      {children}
    </MotionTag>
  );
};

export const Overline = ({ children, className = "" }) => (
  <span className={`font-mono text-xs md:text-sm uppercase tracking-[0.22em] text-brand ${className}`}>
    {children}
  </span>
);

export const SectionHeading = ({ overline, title, intro, align = "left", className = "" }) => (
  <div className={`${align === "center" ? "text-center mx-auto" : ""} max-w-3xl ${className}`}>
    {overline && (
      <Reveal>
        <div className="flex items-center gap-3 mb-5">
          <span className="h-px w-8 bg-brand/60" />
          <Overline>{overline}</Overline>
        </div>
      </Reveal>
    )}
    <Reveal delay={0.06}>
      <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl font-medium tracking-tight text-gradient">
        {title}
      </h2>
    </Reveal>
    {intro && (
      <Reveal delay={0.12}>
        <p className="mt-5 text-base md:text-lg leading-relaxed text-muted-foreground">{intro}</p>
      </Reveal>
    )}
  </div>
);

export const Section = ({ id, children, className = "", glow = false }) => (
  <section id={id} className={`relative py-24 md:py-32 ${className}`}>
    {glow && <div className="pointer-events-none absolute inset-0 section-glow" />}
    <div className="relative container-x">{children}</div>
  </section>
);
